// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paymentHeader_root__3Tw4O {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  box-sizing: border-box;\n  width: 100%;\n  grid-row-gap: 10px;\n  row-gap: 10px;\n  grid-column-gap: 10px;\n  column-gap: 10px;\n  font-size: 12px;\n  font-weight: bold;\n  margin-top: 5px; }\n  .paymentHeader_root__3Tw4O .paymentHeader_column__2u61A {\n    width: 100px;\n    display: flex;\n    align-items: center;\n    font-size: 11px; }\n", ""]);
// Exports
exports.locals = {
	"root": "paymentHeader_root__3Tw4O",
	"column": "paymentHeader_column__2u61A"
};
module.exports = exports;
